<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="queryusertList" :placeholder="'请输入用户名称'" />
    <!-- 添加按钮 -->
    <add-btn v-hasPermi="['system:user:add']" @add="handleAdd"></add-btn>
    <!-- 岗位列表区 start -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div v-for="item in userList" :key="item.userId">
        <van-card v-if="item.dept" :title="item.nickName" :desc="'部门：'+ item.dept.deptName" :thumb="item.avatar">
          <template #tags>
            <van-tag plain type="primary" color="#ddd">{{'email:' + item.email}}</van-tag>
            <van-tag plain type="primary" color="#ddd">{{'Tel:' + item.mobile}}</van-tag>
          </template>
          <template #footer>
            <van-button size="mini" color="#3976c6" plain type="info" round @click="handleUpdate(item)" v-hasPermi="['system:user:edit']">修改</van-button>
            <van-button size="mini" color="#3976c6" plain type="info" round @click="handleDelete(item)" v-hasPermi="['system:user:remove']">删除</van-button>
            <van-button size="mini" color="#3976c6" plain type="info" round @click="handleResetPwd(item)" v-hasPermi="['system:user:resetPwd']">重置</van-button>
          </template>
        </van-card>
      </div>
    </van-list>
    <!-- 岗位列表区 end -->
    <!-- 修改、增加岗位信息弹框区 start -->
    <van-dialog v-model="open" :title="dialog_title" :beforeClose="editPostBeforeClose" close-on-click-overlay>
      <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap">
        <van-cell-group>
          <van-field v-model="form.nickName" label="用户昵称" :rules="[{ required: true, message: '用户昵称不能为空' }]" required />
          <van-field label="归属部门" v-model="form.deptName" required :rules="[{ required: true, message:'部门名称不能为空'}]" />
          <van-field v-model="form.mobile" label="手机号码" />
          <van-field v-model="form.email" label="邮箱" />
          <van-field v-model="form.postName" label="岗位" />
          <van-field v-model="form.userName" v-if="form.userId == undefined" label="用户名称" />
          <van-field v-model="form.password" v-if="form.userId == undefined" label="用户密码" />
          <van-field label="性别">
            <template #input>
              <van-radio-group v-model="form.sex" direction="horizontal">
                <van-radio :name="item.dictValue" v-for="item in sexOptions" :key="item.dictValue" icon-size="14px">{{ item.dictLabel }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field label="状态">
            <template #input>
              <van-radio-group v-model="form.status" direction="horizontal">
                <van-radio :name="item.dictValue" v-for="item in statusOptions" :key="item.dictValue" icon-size="14px">{{ item.dictLabel }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field type="textarea" v-model="form.remark" label="备注" />
        </van-cell-group>
      </van-form>
    </van-dialog>
    <!-- 修改岗位信息弹框区 end -->
  </div>
</template>
<script>
import { Card, List, Collapse, CollapseItem, Icon, SwipeCell, Button, Cell, NoticeBar, Dialog, CellGroup, Form, Field, RadioGroup, Radio, Stepper, Toast, Tag } from 'vant'
import { listUser, getUser, delUser, addUser, updateUser, exportUser, resetUserPwd, changeUserStatus, syncQyWxUser, importTemplate } from "@/api/system/user";
import { getToken } from "@/utils/auth";
import { treeselect } from "@/api/system/dept";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import AddBtn from "@/components/common/AddBtn";
import SearchComponent from "@/components/common/Search";
export default {
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Card.name]: Card,
    [Stepper.name]: Stepper,
    [Button.name]: Button,
    [SwipeCell.name]: SwipeCell,
    [NoticeBar.name]: NoticeBar,
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Tag.name]: Tag,
    [Dialog.Component.name]: Dialog.Component,
    AddBtn,
    SearchComponent,
    // Treeselect,
  },
  data() {
    return {
      open: false,
      form: {},
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        nickName: null,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      searchValue: null,
      radio: '1',
      statusOptions: this.$store.state.dictOptions.status || [],
      userList: [],
      dialog_title: '',
      finished: false,
      loading: false,
      // 部门树选项
      deptOptions: [],
      // 性别状态字典
      sexOptions: this.$store.state.dictOptions.sex || [],
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getList()
      await this.getTreeselect();
      //状态字段
      // this.getDicts("sys_normal_disable").then(response => {
      //   this.statusOptions = response.data;
      // });
      // this.getDicts("sys_user_sex").then(response => {
      //   this.sexOptions = response.data;
      // });
    },
    // 搜索
    queryusertList(data) {
      this.queryParams.nickName = this.searchValue = data;
      this.userList = [];
      this.getList();
    },
    /** 查询用户列表 */
    async getList() {
      this.loading = true
      let response = await listUser(this.queryParams);
      if (response.code === 200) {
        this.userList = this.userList.concat(response.rows);
        this.queryParams.pageNum += 1;
        this.loading = false;
        this.finished = this.userList.length >= response.total;
      }
    },
    // 向下滚动刷新
    async onLoad() {
      await this.getList()
    },
    // 表单重置
    reset() {
      this.form = {
        postId: null,
        postCode: null,
        postName: null,
        postSort: 0,
        status: "0",
        remark: null
      };
    },
    // 关闭修改合同弹框
    async editPostBeforeClose(action, done) {
      if (action === 'confirm') {
        try {
          await this.$refs["form"].validate();
          let api = this.form.postId != undefined ? updatePost : addPost,
            msg = this.form.postId != undefined ? '修改成功' : '新增成功';
          api(this.form).then(response => {
            Toast.success(msg);
            this.open = false;
            this.getList();
          });
          done();
        } catch (err) {
          return done(false);
        }
      } else {
        return done();
      }
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.postId != undefined) {
            updatePost(this.form).then(response => {
              this.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addPost(this.form).then(response => {
              this.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.dialog_title = "添加岗位";
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const postIds = row.postId;
      Dialog.confirm({
        title: "警告",
        message: '是否确认删除岗位编号为"' + postIds + '"的数据项?',
      })
        .then(function () {
          return delPost(postIds);
        })
        .then(() => {
          Toast.success("删除成功");
          this.getList();
        })
        .catch(() => { });
    },
    /** 查询部门下拉树结构 */
    getTreeselect() {
      treeselect().then(response => {
        console.log(response);
        this.deptOptions = response.data;
      });
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      console.log(row);
      this.reset();
      const userId = row.userId;
      getUser(userId).then(response => {
        console.log('getUser', response);
        this.form = response.data;
        // this.postOptions = response.posts;
        // this.roleOptions = response.roles;
        this.form.postIds = response.postIds;
        this.form.roleIds = response.roleIds;
        this.open = true;
        this.dialog_title = "修改用户";
        this.form.password = "";
      });
    },

  },
}
</script>
<style lang="less">
@import url("@/style/index.less");

.van-card {
  background-color: #fff;
}
.van-card__title,
.van-card__desc {
  margin-bottom: 12px;
}
.van-tag {
  margin-right: 5px;
  margin-bottom: 5px;
}
.van-button {
  width: 80px;
}
</style>